import React from 'react';

import { ComplaintForm } from '@lendi-jam/complaint-form';

import { getAllBrokerList } from '../utils/getBrokers';

const PrismicGenericComplaintForm: React.FC = () => (
  <ComplaintForm
    getBrokerList={getAllBrokerList}
  />
);

export default PrismicGenericComplaintForm;